import { createContext, useContext, ReactNode, useMemo } from 'react';

interface PageWrapperDataContextProps {
  labels: GlobalLabels;
  siteSettings: SiteSettings;
  featuredInductees: PageWrapperData['siteSettings']['featuredInductees'];
  eventTypes: PageWrapperData['eventTypes'];
  siteTitle: string;
  todaysEvents: PageWrapperData['todaysEvents'];
  upcomingEvents: PageWrapperData['upcomingEvents'];
}

const PageWrapperDataContext = createContext<PageWrapperDataContextProps | undefined>(undefined);

type LabelsProviderProps = PageWrapperData & {
  children: ReactNode;
};

export const PageWrapperDataProvider: React.FC<LabelsProviderProps> = ({ globalLabels, siteSettings, upcomingEvents, todaysEvents, eventTypes, children }) => {
  const value = useMemo(() => ({
    labels: globalLabels?.labels || {},
    siteSettings: siteSettings?.customSettings || {},
    featuredInductees: siteSettings?.featuredInductees || { nodes: [] },
    siteTitle: siteSettings?.customSettings?.siteTitle || 'Rock & Roll Hall of Fame',
    eventTypes: eventTypes || { nodes: [] },
    todaysEvents: todaysEvents || [],
    upcomingEvents: upcomingEvents || []
  }), [globalLabels, siteSettings, upcomingEvents, todaysEvents, eventTypes]);
  return (
    <PageWrapperDataContext.Provider value={value}>
      {children}
    </PageWrapperDataContext.Provider>
  )
};

export const usePageWrapperData = () => {
  const context = useContext(PageWrapperDataContext);
  return context || {
    labels: {},
    siteSettings: {},
    featuredInductees: { nodes: [] },
    eventTypes: { nodes: [] },
    siteTitle: 'Rock & Roll Hall of Fame',
    todaysEvents: [],
    upcomingEvents: []
  } as PageWrapperDataContextProps;
};